import { render, staticRenderFns } from "./ListenerFavourites.vue?vue&type=template&id=3039068d&scoped=true"
import script from "./ListenerFavourites.vue?vue&type=script&lang=js"
export * from "./ListenerFavourites.vue?vue&type=script&lang=js"
import style0 from "./ListenerFavourites.vue?vue&type=style&index=0&id=3039068d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3039068d",
  null
  
)

export default component.exports